__turbopack_context__.v({
  "className": "barlow_condensed_fec593d1-module__9qaEJG__className",
  "variable": "barlow_condensed_fec593d1-module__9qaEJG__variable",
});
